module.exports = __webpack_public_path__ + "static/media/login-right-arrow.a319b6ca.png";